import { Collapsible as ArkCollapsible } from "@ark-ui/react/collapsible";
import { collapseStyles } from "@theme/recipes/collapse";

type Props = {
  children: any;
  isOpened: boolean;
};

export default function Collapse({ children, isOpened }: Props) {
  const { content, root } = collapseStyles();

  return (
    <ArkCollapsible.Root className={root} open={isOpened}>
      <ArkCollapsible.Content className={content}>{children}</ArkCollapsible.Content>
    </ArkCollapsible.Root>
  );
}
